import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, err } from "../../lib/api";

function PermPicker({ all, value, onChange, idPrefix }) {
  const flip = p => onChange(value.includes(p) ? value.filter(x => x !== p) : [...value, p]);
  return <div className="perm-grid">{all.map(p => <label key={p}><input type="checkbox" checked={value.includes(p)} onChange={() => flip(p)} data-testid={`${idPrefix}-perm-${p}`} />{p}</label>)}</div>;
}

export default function AdminAdmins({ admin }) {
  const [d, setD] = useState(null), [f, setF] = useState({ phone: "", name: "", password: "", permissions: ["transactions"] });
  const load = useCallback(() => api.get("/admin/admins").then(r => setD(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const create = async () => { try { await api.post("/admin/admins", f); toast.success("Admin created"); setF({ phone: "", name: "", password: "", permissions: ["transactions"] }); load(); } catch (e) { toast.error(err(e)); } };
  const update = async (phone, body) => { try { await api.patch(`/admin/admins/${phone}`, body); toast.success("Admin updated"); load(); } catch (e) { toast.error(err(e)); } };
  if (!d) return <div className="admin-section">Loading…</div>;
  return (
    <>
      <section className="admin-section"><h2>Admin accounts & permissions</h2>
        {d.admins.map(a => {
          const locked = a.phone === admin.phone || (a.permissions || []).includes("all");
          return (
            <div className="admin-tx" key={a.phone} data-testid={`admin-account-${a.phone}`}>
              <div><b>{a.name} · {a.phone}</b>{locked ? <small>{(a.permissions || []).includes("all") ? "Super admin · all permissions" : "Your account"}</small> : <PermPicker all={d.permissions} value={a.permissions || []} idPrefix={a.phone} onChange={p => update(a.phone, { permissions: p })} />}</div>
              <span className={`status ${a.status}`}>{a.status}</span>
              {!locked && <button className={`btn ${a.status === "active" ? "red" : "green"}`} onClick={() => update(a.phone, { status: a.status === "active" ? "suspended" : "active" })} data-testid={`toggle-admin-${a.phone}`}>{a.status === "active" ? "Suspend" : "Activate"}</button>}
            </div>);
        })}
      </section>
      <section className="admin-section"><h2>Create sub-admin</h2>
        <div className="admin-form">
          <label>Phone<input value={f.phone} onChange={e => setF({ ...f, phone: e.target.value })} data-testid="new-admin-phone-input" /></label>
          <label>Name<input value={f.name} onChange={e => setF({ ...f, name: e.target.value })} data-testid="new-admin-name-input" /></label>
          <label>Password (min 8)<input type="password" value={f.password} onChange={e => setF({ ...f, password: e.target.value })} data-testid="new-admin-password-input" /></label>
          <div className="full"><PermPicker all={d.permissions} value={f.permissions} idPrefix="new-admin" onChange={p => setF({ ...f, permissions: p })} /></div>
          <div className="full"><button className="btn green" onClick={create} data-testid="create-admin-button">Create admin</button></div>
        </div>
      </section>
    </>
  );
}
